import { Injectable } from '@angular/core';
import { TLoadDependeciesParams } from '@df/catalog/model';
import { ICmsPageResource } from '@icms/core/resource/page/icms-page.resource';
import { NBlogCategoryPageType } from '../../../cms/blog/page/category-view/cms-blog-page-category-view.component';
import { NBlogPostPageType } from '../../../cms/blog/page/post-view/cms-blog-page-post-view.component';
import { NBlogRootPageType } from '../../../cms/blog/page/root-view/cms-blog-page-root-view.component';
import { NMaterialCalculatorPageType } from '../../../materials-calculator/page/material-calculator-cms-page';
import { LocalPage } from './local-page';

@Injectable({
    providedIn: 'root'
})
export class LocalPageResource extends ICmsPageResource<LocalPage> {
    static override instance = LocalPage;

    loadBlogRoot(verbosity = 2, params: TLoadDependeciesParams): Promise<LocalPage[]> | void {
        return this.find({ filter: { pageType: NBlogRootPageType.typeId }, verbosity }, params);
    }
    /**
     * Loads all blog categories
     */
    loadBlogCategories(verbosity = 2, params: TLoadDependeciesParams): Promise<LocalPage[]> | void {
        return this.find({ filter: { pageType: NBlogCategoryPageType.typeId }, verbosity }, params);
    }
    /**
     * Loads all blog posts
     */
    loadBlogPosts(verbosity = 2, params: TLoadDependeciesParams): Promise<LocalPage[]> | void {
        return this.find({ filter: { pageType: NBlogPostPageType.typeId }, verbosity }, params);
    }

    /**
     * Loads all calculators
     */
    loadCalculators(verbosity = 2, params: TLoadDependeciesParams): Promise<LocalPage[]> | void {
        return this.find({ filter: { pageType: NMaterialCalculatorPageType.typeId }, verbosity }, params);
    }
}
